import { Separator } from '../../atoms/Separator/Separator';
import { RichText } from '../../molecules/RichText/RichText';
import { ProductOverviewProps } from './ProductOverview.types';

/**
 * Wraps emoji characters in `<span aria-hidden="true">` so screen readers
 * skip decorative emojis that would otherwise be announced by Unicode name.
 */
const hideDecorativeEmojis = (html: string): string =>
  html.replace(
    /(\p{Extended_Pictographic})/gu,
    '<span aria-hidden="true">$1</span>'
  );

export const ProductOverview = ({
  summary,
  description,
  microcopy,
  className = '',
}: ProductOverviewProps) => {
  return (
    <section className={className}>
      <p className="body mt-8 whitespace-pre-line md:mt-0">{summary}</p>

      {summary ? <Separator className="mb-8 mt-8 md:mb-9 md:mt-12" /> : null}

      <h2 className="body-bold mb-8 font-medium md:mb-8">{microcopy.title}</h2>

      <RichText
        html={hideDecorativeEmojis(description)}
        className="[&_h3]:body-bold [&_h3]:mb-6 [&_h3]:font-medium md:[&_h3]:mb-8"
      />
    </section>
  );
};
